import { useAppDispatch, useAppSelector } from '@/state/hooks';
import { clearHighlightedTarget, selectHelperHighlightedTarget } from '@/state/reducers/helperSlice';
import { useEffect, useRef } from 'react';

const HELPER_HIGHLIGHT_CLASS = 'helper-highlight-target';

const HelperHighlightManager = () => {
    const dispatch = useAppDispatch();
    const highlightedTarget = useAppSelector(selectHelperHighlightedTarget);
    const highlightStartedAtRef = useRef<number>(0);

    useEffect(() => {
        let targetElement: HTMLElement | null = null;

        if (highlightedTarget?.selector) {
            targetElement = document.querySelector<HTMLElement>(highlightedTarget.selector);
            if (targetElement) {
                targetElement.classList.add(HELPER_HIGHLIGHT_CLASS);
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        }

        return () => {
            if (targetElement) {
                targetElement.classList.remove(HELPER_HIGHLIGHT_CLASS);
            }
        };
    }, [highlightedTarget]);

    useEffect(() => {
        if (!highlightedTarget) {
            return;
        }
        highlightStartedAtRef.current = Date.now();

        const clearHighlightOnInteraction = () => {
            if (Date.now() - highlightStartedAtRef.current < 700) {
                return;
            }
            dispatch(clearHighlightedTarget());
        };

        document.addEventListener('mousedown', clearHighlightOnInteraction, true);
        document.addEventListener('touchstart', clearHighlightOnInteraction, true);

        return () => {
            document.removeEventListener('mousedown', clearHighlightOnInteraction, true);
            document.removeEventListener('touchstart', clearHighlightOnInteraction, true);
        };
    }, [dispatch, highlightedTarget]);

    return null;
};

export default HelperHighlightManager;
